import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { formatAmount } from "../../../utility/CommonFunctions";
import MainHeading from "../../../components/comman/MainHeading";
import {
  Fade,
  Nav,
  NavLink,
  NavItem,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useSelector } from "react-redux";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import PaginationComponent from "../../../components/comman/PaginationComponent";

export default function TdsLedger() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    tdsData: [],
    searchQuery: "",
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    year: "",
    siteId: filterDetails?.siteId,
    siteList: [],
    tdsType: "payable",
    countsData: {},
    companyList: [],
    companyId: "",
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });

  const toggleTab = (tab) => {
    setPageStates((prev) => ({
      ...prev,
      tdsType: tab == 1 ? "payable" : "receivable",
      activeTab: tab,
      currentPage: 1,
      companyId: "",
    }));
    GetSiteList();
  };

  useEffect(() => {
    if (pageStates?.year) {
      GetTdsList();
    }
    if (pageStates?.siteList?.length === 0) {
      GetSiteList();
    }
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.activeTab,
    pageStates.pageSize,
    pageStates.sortByDate,
    pageStates?.year,
    pageStates?.siteId,
    pageStates?.companyId,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  const GetTdsList = () => {
    let options = {
      method: "GET",
    };
    let API =
      apiUrl.get_transaction +
      `?from=tds&type=tds&` +
      MainFilterHandler({
        ...pageStates,
      });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        setPageStates((prevStates) => ({
          ...prevStates,
          tdsData: response?.data?.transaction,
          countsData: { ...response?.data?.counts },
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    setPageStates((pre) => ({
      ...pre,
      ...(type === "site" && { siteId: data?.site }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
  };

  const handleYearChange = (selectedYear) => {
    setPageStates((prev) => ({
      ...prev,
      year: selectedYear,
      sortByDate: isFirstYearChange ? prev.sortByDate : [],
    }));

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  return (
    <>
      <div className="content">
        <MainHeading
          title={"TDS Ledger"}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          <NavItem className="nav-item ">
            <NavLink
              className={
                pageStates?.activeTab === 1
                  ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0  border-end-1 border-start-1 active"
                  : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-1 border-start-1"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(1)}
            >
              TDS Payable
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                pageStates?.activeTab === 2
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-1 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-1 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(2)}
            >
              TDS Receivable
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={pageStates?.activeTab}>
          <TabPane tabId={1}>
            <Fade in={pageStates?.activeTab === 1} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <div className="d-flex gap-3 mb-3 align-items-center justify-content-between text-center">
                    <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                      <h5 className="m-0">
                        Total Entries:{" "}
                        <span className="fw-semibold">
                          {pageStates?.countsData?.totalEntries}
                        </span>
                      </h5>
                    </div>
                    <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                      <h5 className="m-0">
                        Total Amount{" "}
                        <span className="text-info fw-semibold">
                          {formatAmount(
                            pageStates?.countsData?.creditAmount || 0
                          )}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <div className="ledgers">
                    {pageStates?.tableLoader ? (
                      <div className="d-flex justify-content-center my-5 ">
                        <Spinner />
                      </div>
                    ) : pageStates?.tdsData &&
                      pageStates?.tdsData?.length > 0 ? (
                      pageStates?.tdsData
                        ?.slice()
                        .reverse()
                        ?.map((item, index) => (
                          <>
                            {/* // TDS entry */}
                            {item?.type === "tds" && (
                              <div key={index} className="ledger">
                                <span className="icon px-2 py-2">
                                  <span className="fs-5 fw-bold">{moment(item?.createdAt).date()}</span>
                                  <p className="fs-6 m-0">
                                    {moment(item?.createdAt).format("MMM")}
                                  </p>
                                </span>
                                <div>
                                  <p className="time text-muted mb-0">
                                    Trans. Date -{" "}
                                    {moment(item?.transactionDate).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </p>

                                  <p className="time mb-0 mt-0 fw-bold">
                                    TDS - ({item?.paymentticket?.ticketNumber})
                                  </p>
                                </div>
                                <h5 className={"text-info mb-0 ms-auto fw-semibold"}>
                                  {formatAmount(item?.amount || "--")}
                                </h5>
                              </div>
                            )}
                          </>
                        ))
                    ) : (
                      <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                        <NoRecordIcon />
                        {"No record found"}
                      </div>
                    )}
                  </div>
                  <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                    <div className="d-flex align-items-center gap-2">
                      {pageStates?.count > 0 && !pageStates?.tableLoader && (
                        <div className="dropdown short">
                          <button
                            className="btn dropdown-toggle border"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {pageStates?.pageSize}
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                                  stroke="#36394A"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </span>
                          </button>
                          <ul className="dropdown-menu ">
                            {[10, 20, 30, 40, 50].map((value) => (
                              <li key={value}>
                                <button
                                  className={`dropdown-item ${pageStates?.pageSize === value && "active"
                                    }`}
                                  onClick={() => handleChangePageSize(value)}
                                >
                                  {value}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      <div>
                        {pageStates?.count > 0 && !pageStates?.tableLoader && (
                          <p
                            className="mb-0 text-muted fw-medium text-uppercase"
                            style={{ fontSize: "10px" }}
                          >
                            {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                              (pageStates?.pageSize - 1)
                              } to ${pageStates?.currentPage * pageStates?.pageSize <
                                pageStates?.count
                                ? pageStates?.currentPage * pageStates?.pageSize
                                : pageStates?.count
                              } of ${pageStates?.count} entries`}
                          </p>
                        )}
                      </div>
                    </div>

                    <PaginationComponent
                      currentPage={pageStates?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      totalPages={pageStates?.totalPages}
                    />
                  </div>
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={2}>
            <Fade in={pageStates?.activeTab === 2} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <div className="d-flex gap-3 mb-3 align-items-center justify-content-between text-center">
                    <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                      <h5 className="m-0">
                        Total Entries:{" "}
                        <span className="fw-semibold">
                          {pageStates?.countsData?.totalEntries}
                        </span>
                      </h5>
                    </div>
                    <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                      <h5 className="m-0">
                        Total Amount{" "}
                        <span className="text-info fw-semibold">
                          {formatAmount(
                            pageStates?.countsData?.debitAmount || 0
                          )}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <div className="ledgers">
                    {pageStates?.tableLoader ? (
                      <div className="d-flex justify-content-center my-5 ">
                        <Spinner />
                      </div>
                    ) : pageStates?.tdsData &&
                      pageStates?.tdsData?.length > 0 ? (
                      pageStates?.tdsData
                        ?.slice()
                        .reverse()
                        ?.map((item, index) => (
                          <>
                            {/* // TDS entry */}
                            {item?.type === "tds" && (
                              <div key={index} className="ledger">
                                <span className="icon px-2 py-2">
                                  <span className="fs-5 fw-bold">{moment(item?.createdAt).date()}</span>
                                  <p className="fs-6 m-0">
                                    {moment(item?.createdAt).format("MMM")}
                                  </p>
                                </span>
                                <div>
                                  <p className="time text-muted mb-0">
                                    Trans. Date -{" "}
                                    {moment(item?.transactionDate).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </p>

                                  <p className="time mb-0 mt-0 fw-bold">
                                    TDS - ({item?.invoice?.invoiceNumber})
                                  </p>
                                </div>
                                <h5 className={"text-info mb-0 ms-auto fw-semibold"}>
                                  {formatAmount(item?.amount || "--")}
                                </h5>
                              </div>
                            )}
                          </>
                        ))
                    ) : (
                      <div className="d-flex flex-column justify-colmn-center align-items-center no-data-error">
                        <NoRecordIcon />
                        {"No record found"}
                      </div>
                    )}
                  </div>
                  <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
                    <div className="d-flex align-items-center gap-2">
                      {pageStates?.count > 0 && !pageStates?.tableLoader && (
                        <div className="dropdown short">
                          <button
                            className="btn dropdown-toggle border"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {pageStates?.pageSize}
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                                  stroke="#36394A"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </span>
                          </button>
                          <ul className="dropdown-menu ">
                            {[10, 20, 30, 40, 50].map((value) => (
                              <li key={value}>
                                <button
                                  className={`dropdown-item ${pageStates?.pageSize === value && "active"
                                    }`}
                                  onClick={() => handleChangePageSize(value)}
                                >
                                  {value}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      <div>
                        {pageStates?.count > 0 && !pageStates?.tableLoader && (
                          <p
                            className="mb-0 text-muted fw-medium text-uppercase"
                            style={{ fontSize: "10px" }}
                          >
                            {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                              (pageStates?.pageSize - 1)
                              } to ${pageStates?.currentPage * pageStates?.pageSize <
                                pageStates?.count
                                ? pageStates?.currentPage * pageStates?.pageSize
                                : pageStates?.count
                              } of ${pageStates?.count} entries`}
                          </p>
                        )}
                      </div>
                    </div>

                    <PaginationComponent
                      currentPage={pageStates?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      totalPages={pageStates?.totalPages}
                    />
                  </div>
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
}
